const ROWS = [
  '서울교통공사 실시간 이용정보',
  '국세청 사업자등록 진위확인',
  'SRT 승차권 데이터',
  '법제처 특별행정심판 재결례',
];

/** AI Data Verifier 쇼케이스용 rows 비주얼 — 실시간 진위확인 처리 현황. */
export default function VerifierRows() {
  return (
    <div className="pd-rows">
      <div className="pd-rows__head">
        <span className="pd-rows__title">진위확인 처리 현황</span>
        <span className="pd-rows__live">REAL-TIME</span>
      </div>
      <div className="pd-rows__list">
        {ROWS.map((name) => (
          <div className="pd-rows__row" key={name}>
            <span className="pd-rows__check" aria-hidden>
              ✓
            </span>
            <span className="pd-rows__name">{name}</span>
            <span className="pd-rows__status">검증완료</span>
          </div>
        ))}
      </div>
    </div>
  );
}
